import React, { useState, useEffect, useContext } from "react";
import { Typography, Input, Button, Dropdown, Menu, Icon, message } from "antd";
import { withRouter } from "react-router-dom";
import { ContextAPI } from "../../../ContextAPI";
import { platformApi } from "../../../api";
import SpareAdjustmentTable from "./SpareAdjustmentTable";
import SpareAdjustmentForm from "./SpareAdjustmentForm";

const { Title } = Typography;
const { Search } = Input;
const { Item } = Menu;

const SpareAdjustment = () => {
  const { loginCredintials } = useContext(ContextAPI);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [searchString, setSearchString] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [editable, setEditable] = useState(false);

  const [createAccess, setCreateAccess] = useState(false);
  const [deleteAccess, setDeleteAccess] = useState(false);
  const [sectionHighlight, setSectionHighlight] = useState(false);

  useEffect(() => {
    let timer = null;
    const storedTime = sessionStorage.getItem("sparesAdjustmentHighlightTime");
    if (storedTime && Date.now() - parseInt(storedTime, 10) < 3000) {
      const remainingTime = 3000 - (Date.now() - parseInt(storedTime, 10));
      setSectionHighlight(true);
      timer = setTimeout(() => {
        setSectionHighlight(false);
        sessionStorage.removeItem("sparesAdjustmentHighlightTime");
      }, remainingTime);
    }

    const handleStockAdjustment = () => {
      setSectionHighlight(true);
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        setSectionHighlight(false);
      }, 3000);
    };

    window.addEventListener("stockAdjustmentCreated", handleStockAdjustment);
    return () => {
      window.removeEventListener("stockAdjustmentCreated", handleStockAdjustment);
      if (timer) clearTimeout(timer);
    };
  }, []);

  useEffect(() => {
    if (loginCredintials?.roleAccess) {
      const access = loginCredintials.roleAccess.find(
        (each) => each.subModule === "Spares_Adjustment"
      );
      if (access) {
        setCreateAccess(access.access.create);
        setDeleteAccess(access.access.delete);
      }
    }
    getData();
  }, [page, limit, searchString]);

  const getData = async () => {
    setLoading(true);
    try {
      const response = await platformApi.post("/api/AdjustSparesInventory/get", {
        page,
        size: limit,
        searchString,
      });
      if (response.data.code === 200) {
        setData(response.data.response?.data?.history || []);
        setCount(response.data.response?.data?.count || 0);
      } else {
        message.error("Failed to fetch spares adjustment data");
      }
    } catch (error) {
      console.error("Error fetching spares adjustment data:", error);
      message.error("An error occurred while fetching data");
    } finally {
      setLoading(false);
    }
  };

  const deleteData = (id) => {
    setLoading(true);
    platformApi
      .delete(`/api/AdjustSparesInventory/${id}`)
      .then((res) => {
        if (res.data.code === 200) {
          message.success("Record Deleted Successfully");
          getData();
        } else {
          message.error("Failed to delete record");
        }
      })
      .catch((err) => {
        console.error("Error deleting record:", err);
        message.error("Unable to delete record");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onRowClick = (record) => {
    setSelectedData(record);
    setEditable(false);
    setModalOpen(true);
  };

  const getMenu = () => {
    const menus = [10, 20, 50, 100];
    return menus.map((menu) => (
      <Item
        onClick={() => {
          setLimit(menu);
          setPage(1);
        }}
        key={menu}
      >
        {menu}
      </Item>
    ));
  };

  const menu = <Menu>{getMenu()}</Menu>;

  return (
    <div>
      <div
        className="accessories-head"
        style={sectionHighlight ? { backgroundColor: "#fff1f0", borderLeft: "4px solid #ff4d4f", borderRadius: "4px", padding: "8px 12px", transition: "all 0.4s ease" } : { padding: "8px 12px", transition: "all 0.4s ease" }}
      >
        <Title style={{ width: "60%" }} level={4}>
          Spares Adjustment [{count}]
          <span style={{ margin: ".5rem" }}>
            <Dropdown overlay={menu} trigger={["click"]}>
              <Button>
                {limit} &nbsp; &nbsp;
                <Icon type="down" />
              </Button>
            </Dropdown>
          </span>
        </Title>
        <Search
          style={{ width: "30%" }}
          placeholder="Search by Part Number"
          onSearch={(val) => {
            setSearchString(val);
            setPage(1);
          }}
          onChange={(e) => {
            if (!e.target.value) {
              setSearchString("");
              setPage(1);
            }
          }}
        />
        <Button
          type="primary"
          style={{ marginLeft: "10px" }}
          onClick={() => {
            setSelectedData({});
            setEditable(true);
            setModalOpen(true);
          }}
          disabled={!createAccess && loginCredintials.role !== "ADMIN"}
        >
          Add Spare Adjustment
        </Button>
      </div>

      <SpareAdjustmentTable
        data={data}
        loading={loading}
        pagination={{
          onChange: (p) => setPage(p),
          pageSize: limit,
          current: page,
          total: count,
          showQuickJumper: true,
        }}
        onRowClick={onRowClick}
        deleteData={deleteData}
        deleteAccess={deleteAccess}
      />

      {modalOpen && (
        <SpareAdjustmentForm
          open={modalOpen}
          close={() => {
            setModalOpen(false);
            setSelectedData({});
          }}
          selectedData={selectedData}
          editable={editable}
          refreshData={getData}
        />
      )}
    </div>
  );
};

export default withRouter(SpareAdjustment);
